module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-uz-3782ddeb59f9fe28dc83d5e8eaa902a1.png";